import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <p><strong>Description</strong></p>
  <p>
      Associates are being placed in processes without proper training This is against Amazon policies and network standard and needs to be mitigated immediately. There is a proven elevated safety risk involved for Associates placed, but
      not properly trained in processes. Proper training is key to associate safety, quality and productivity.&nbsp;
  </p>
  <p><strong>Resolution Steps If the AA is On-Site</strong></p>
  <p>
      1) Remove the associate from path and return them to their home process.<br />
      2) Provide the associate with proper training prior to placing them in the path removed.
  </p>
  <p><strong>Resolution Steps If the individual is NOT On-Site</strong></p>
  <p>
      1) Close ATV Alerts for individuals not in the building, and comment what caused the error. <br />
      2) Verify PPA Labor Tracking. <br />
      3) Audit to confirm there are no broken, faded or damaged labor tracking barcodes. Damaged barcodes can cause false ATV Alerts if only a portion of the barcode is read causing leaders outside of AMZL with low badge IDs to be labor
      tracked.
  </p>
  <p><strong>Supplemental Links</strong></p>
  <p>
      1) <span className="wikiinternallink"><a href="https://fclearning.amazon.com/fcl/viewtranscript">Associate Learning Transcript</a></span><br />
      2)
      <span className="wikiinternallink">
          <a
              href="https://us-east-1.signin.aws.amazon.com/oauth?SignatureVersion=4&amp;X-Amz-Algorithm=AWS4-HMAC-SHA256&amp;X-Amz-Credential=AKIAIYOJP4OBNT7XFVSQ&amp;X-Amz-Date=2021-05-12T18%3A20%3A05.291Z&amp;X-Amz-Signature=f71b19e6c278184243fc5e1cb271ae1c43b49f8947bf2a42277ff05186753b75&amp;X-Amz-SignedHeaders=host&amp;client_id=arn%3Aaws%3Aiam%3A%3A015428540659%3Auser%2Fspaceneedle-prod&amp;isauthcode=true&amp;qs-signin-user-auth=false&amp;response_type=code&amp;state=hashArgs%23&amp;redirect_uri=https%3A%2F%2Fus-east-1.quicksight.aws.amazon.com%2Fsn%2Fdashboards%2Fcd2f06cf-6158-42d4-a09c-e70dbeafd913%2Fsheets%2Fcd2f06cf-6158-42d4-a09c-e70dbeafd913_5283a8ac-97b0-4952-8c0e-f0271597262a%3Fdirectory_alias%3Damazonbi%26qs-signin-user-auth%3Dfalse%26state%3DhashArgs%2523%26isauthcode%3Dtrue&amp;qs-signin-account-name=amazonbi&amp;directory_alias=amazonbi&amp;rdfs=true"
          >
              AMZL Training Quicksight
          </a>
      </span>
      <br />
      3) <span className="wikiinternallink"><a href="https://fclm-portal.amazon.com">FCLM Associate Time Details</a></span><br />
      4) <span className="wikiinternallink"><a href="https://w.amazon.com/bin/view/Amzltechsme2021bulletins/">False ATV Generation Bulletin</a></span>
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_ATV.jsx